import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import { ScheduledDeleteInput } from "types/generated";

import { CREATE_STACK_SCHEDULING_SCHEDULED_DELETE } from "./gql";

type UseCreateScheduledDelete = {
  stackId: string;
};

const useCreateScheduledDelete = ({ stackId }: UseCreateScheduledDelete) => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const [stackScheduledDeleteCreate, { loading }] = useMutation(
    CREATE_STACK_SCHEDULING_SCHEDULED_DELETE,
    {
      refetchQueries: ["GetStackScheduling"],
      awaitRefetchQueries: true,
    }
  );

  const createScheduledDelete = useCallback(
    (input: ScheduledDeleteInput, successCallback?: () => void) => {
      stackScheduledDeleteCreate({
        variables: {
          stack: stackId,
          input,
        },
      })
        .then(({ data }) => {
          if (data?.stackScheduledDeleteCreate) {
            reportSuccess({
              message: `Delete Stack schedule was set up successfully.`,
            });
            successCallback?.();
          }
        })
        .catch(onError);
    },
    [onError, reportSuccess, stackId, stackScheduledDeleteCreate]
  );

  return {
    createScheduledDelete,
    loading,
  };
};

export default useCreateScheduledDelete;
